module.exports = __webpack_public_path__ + "static/media/5.7c93576f.jpg";